/*
 * @Author: XiuJie_Lin xiujie_lin@lebo.cn
 * @Date: 2023-05-10 14:54:56
 * @LastEditors: XiuJie_Lin xiujie_lin@lebo.cn
 * @LastEditTime: 2023-05-10 20:45:45
 * @FilePath: \web-sass\src\api\markManage\hotList.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from "@/axios";

/** 热门投屏榜分页查询 */
export const getHotList = params => {
  return request({
    url: "/lebo-rabbit/popular-cast/list",
    method: "get",
    params
  });
};

/** 修改热门投屏影片热度值 */
export const updateHotList = data => {
  return request({
    url: `/lebo-rabbit/popular-cast/hotval/${data.mediaId}`,
    method: "put",
    params: {
      hotval: data.hotval
    }
  });
};

/** 下架热门投屏影片 */
export const takeOffHotList = id => {
  return request({
    url: `/lebo-rabbit/popular-cast/take-off/${id}`,
    method: "post"
  });
};

/** 上架热门投屏影片 */
export const takeOnHotList = id => {
  return request({
    url: `/lebo-rabbit/popular-cast/put-on/${id}`,
    method: "post"
  });
};

/** 从媒资库添加热门影片 */
export const addHotList = data => {
  return request({
    url: `/lebo-rabbit/popular-cast/add-from-media-asset/${data.mediaId}`,
    method: "post",
    params: {
      sortNo: data.sortNo
    }
  });
};
/** 修改热门投屏影片顺序 */
export const updateHotListOrder = data => {
  return request({
    url: `/lebo-rabbit/popular-cast/update-sort-no/${data.mediaId}`,
    method: "put",
    params: {
      sortNo: data.sortNo
    }
  });
};
